import { createFileRoute, Navigate } from '@tanstack/react-router';

import { CareCoordinatorManagement } from '@apps/web/components/settings/care_coordinator_management';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/care-coordinators')({
    component: CareCoordinatorsPage,
});

function CareCoordinatorsPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings || !gates.careCoordinator) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Care coordinators"
            description="Link external coordinators to Phoebe users."
        >
            <CareCoordinatorManagement organizationId={organizationId} />
        </SettingsPageShell>
    );
}
